<template>
	<div><slot v-bind:data="data" v-bind:resourceFetched="resourceFetched"></slot></div>
</template>

<script>
	import axios from 'axios';
	export default {
		data(){
			return {
				resourceFetched: false
			}
		},
		computed:{
			data(){
				return this.resourceFetched === true && typeof resourcesData[this.resource] !== 'undefined' ? resourcesData[this.resource] : null ;
			}
		},
		methods: {
			fetchResourceData()
			{
				const that = this;
				axios({method: 'GET', url: this.resource+'?v='+process.env.VUE_APP_STATIC_CONTENT_VERSION})
				.then(response => {
					resourcesData[that.resource] = response.data;
					that.resourceFetched = true;
				})
			}
		},
		mounted()
		{
			if(typeof resourcesData[this.resource] !== 'undefined')
			{
				this.resourceFetched = true;
			}
			else
			{
				this.fetchResourceData()
			}
		},
		props:{
			resource:{
				type: String,
				required:true
			}
		}
	};
</script>

<style scoped>

</style>
